import {
  BlackvueDarkColors,
  BlackvueLightColors,
} from '@thingsw/pitta-modules';

export const gaugeColor = (value: number, status: string) => {
  if (status === 'charging') {
    return {
      first: BlackvueLightColors.secondary['15'],
      second: BlackvueDarkColors.secondary['15'],
    };
  }

  if (status === 'disconnected') {
    return {
      first: BlackvueLightColors.primary['2'],
      second: BlackvueLightColors.primary['3'],
    };
  }

  if (value >= 60) {
    return {
      first: BlackvueLightColors.primary['7'],
      second: BlackvueLightColors.primary['8'],
    };
  }

  if (value >= 20) {
    return {
      first: BlackvueLightColors.secondary['17'],
      second: BlackvueDarkColors.secondary['19'],
    };
  }

  if (value <= 19) {
    return {
      first: BlackvueLightColors.secondary['11'],
      second: BlackvueLightColors.secondary['12'],
    };
  }

  return {
    first: BlackvueLightColors.primary['5'],
    second: BlackvueLightColors.primary['6'],
  };
};
